<div class="payment-component">
    <!-- Define the reusable error template -->
    <ng-template #errorTemplate let-errorMessage="errorMessage" let-title="title">
        <div class="error-message">
            <div class="parent-container d-flex justify-content-center align-items-center">
                <div class="icon-container">
                </div>
                <div class="text-container">
                    <div>
                        <p style="font-size: 80px; font-weight: bold">{{ title }}</p>
                        <p style="font-size: 20px; font-weight: bold">Oops! {{ errorMessage.header }}</p>
                        <p>{{ errorMessage.details }}</p>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div [ngSwitch]="orderInfoState.status">
        <!-- Loading State -->
        <div *ngSwitchCase="'Loading'">
            <h2>Loading Subscription Details ...</h2>
        </div>
        <!-- Fetching State -->
        <div *ngSwitchCase="'NotFetched'">
            <h2>Loading Subscription Details ...</h2>
        </div>

        <!-- Success State -->
        <div *ngSwitchCase="'Success'">
            <button class="custom-back-button" title="Billing History" (click)="onPreviousPageBtnClick()">
                <span class="material-symbols-outlined">arrow_left_alt</span>
                Back
            </button>

            <div class="label-container">
                <h2>Transaction Details</h2>
                <span style="font-weight: bold;">Transaction Number: </span>
                <span>{{order?.Name}}</span>
            </div>
            <div [ngSwitch]="subscriptionPlanState.status">
                <!-- Loading Subscription Plan -->
                <div *ngSwitchCase="'Loading'">
                    <h4>Loading Subscription Plan...</h4>
                </div>
                <!-- Not Fetched Subscription Plan -->
                <div *ngSwitchCase="'NotFetched'">
                    <h4>Loading Subscription Plan...</h4>
                </div>
                <!-- Subscription Plan Failure -->
                <div *ngSwitchCase="'Failure'">
                    <ng-container *ngTemplateOutlet="errorTemplate; context: {
                        errorMessage: {
                            header: 'Subscription Plan Not Found',
                            details: subscriptionPlanState.error || 'Failed to load subscription plan details. Please try again later.'
                        },
                        title: 'Error'
                    }"></ng-container>
                </div>
                <!-- Subscription Plan Success -->
                <div *ngSwitchCase="'Success'">
                    <div class="main-container"
                        *ngIf="orderInfoState.status === 'Success' && subscriptionPlanState.status === 'Success'">
                        <div class="row">

                            <!-- Order Summary Card -->
                            <div class="col-5">
                                <div class="card summary-card">
                                    <div class="card-body">
                                        <h4 class="card-title" style="text-align: center;">Payment Summary</h4>
                                        <div class="d-flex justify-content-between mb-2">
                                            <div class="label-currency">
                                                <span>Plan:</span>
                                            </div>
                                            <span class="amount">{{subscriptionPlan?.Name}}</span>
                                        </div>
                                        <hr>
                                        <div class="d-flex justify-content-between mb-2">
                                            <div class="label-currency">
                                                <span>Billing Cycle:</span>
                                            </div>
                                            <span class="amount">{{subscriptionPlan?.BillingCycle}}</span>
                                        </div>
                                        <hr>
                                        <div class="d-flex justify-content-between mb-2">
                                            <div class="label-currency">
                                                <span>Price:</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(subscriptionPlan?.Price,
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                        <div class="d-flex justify-content-between mb-2 discount"
                                            *ngIf="subscriptionPlan && getDiscount(subscriptionPlan!) as discount">
                                            <div class="label-currency">
                                                <span>Discount (Save
                                                    {{getDiscountedPercentage(subscriptionPlan)}}%):</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(subscriptionPlan?.Discount,
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                        <hr>
                                        <div class="d-flex justify-content-between mb-2"
                                            *ngIf="subscriptionPlan?.Price != getDiscountedPrice(subscriptionPlan)">
                                            <div class="label-currency">
                                                <span>Discounted Price:</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(getDiscountedPrice(subscriptionPlan),
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                        <hr *ngIf="subscriptionPlan?.Price != getDiscountedPrice(subscriptionPlan)">
                                        <div class="d-flex justify-content-between mb-2"
                                            *ngIf="subscriptionPlan?.Currency === 'INR'">
                                            <div class="label-currency">
                                                <span>GST:</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(subscriptionPlan?.GST,
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                        <div class="d-flex justify-content-between mb-2"
                                            *ngIf="subscriptionPlan?.Currency !== 'INR' && subscriptionPlan?.OtherTax">
                                            <div class="label-currency">
                                                <span>Other Tax:</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(subscriptionPlan?.OtherTax,
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                        <hr *ngIf="subscriptionPlan?.Currency === 'INR' || subscriptionPlan?.OtherTax">
                                        <div class="d-flex justify-content-between">
                                            <div class="label-currency">
                                                <span>Final Amount:</span>
                                            </div>
                                            <span class="amount">{{getCurrSymbol(subscriptionPlan?.Currency || '')}}
                                                {{formatAmount(subscriptionPlan?.FinalAmount,
                                                subscriptionPlan?.Currency)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- Order Status -->
                            <div class="col-7 status-container">
                                <div [ngSwitch]="order?.Status">
                                    <ng-container *ngFor="let status of statuses">
                                        <div *ngSwitchCase="status.enum"
                                            class="order-status-{{status.enum | lowercase}}">
                                            <span class="status-label">Subscription Status:
                                                <span class="{{status.enum | lowercase}}-color">{{order?.Status}}</span>
                                            </span>
                                            <button type="button" class="refresh-status-btn" title="Refresh Status"
                                                *ngIf="showRefreshOrderStatusBtn()" (click)="onRefreshStatusBtnClick()"
                                                style="margin-left: 20px;">
                                                <span class="material-symbols-outlined refresh-icon">refresh</span>
                                            </button>
                                            <div>
                                                <span class="status-label">Payment Status:
                                                    <span
                                                        class="{{status.enum | lowercase}}-color">{{order?.PaymentStatus}}</span>
                                                </span>
                                            </div>
                                            <p class="order-status-msg-{{status.enum | lowercase}}">{{status.message}}
                                            </p>
                                        </div>
                                    </ng-container>
                                    <div *ngSwitchDefault>
                                        <span class="status-label">Subscription Status:
                                            <span>{{order?.Status}}</span></span>
                                        <button type="button" class="refresh-status-btn"
                                            *ngIf="showRefreshOrderStatusBtn()" (click)="onRefreshStatusBtnClick()"
                                            style="margin-left: 20px;">Refresh</button>
                                        <p>Unable to process status. Please refresh or contact support.</p>
                                    </div>
                                </div>

                                <button type="button" class="payment-btn" (click)="onPayBtnClick()"
                                    *ngIf="showPaymentBtn()">Pay With Razorpay</button>

                                <div class="alert payment-order-status" [ngClass]="{
                                        'alert-info': generatePaymentOrderState.status === 'Loading',
                                        'alert-danger': generatePaymentOrderState.status === 'Failure',
                                        'alert-success': paymentSuccessMsg
                                    }" *ngIf="generatePaymentOrderState.status || paymentSuccessMsg">
                                    {{generatePaymentOrderState.status === 'Loading' ? 'Generating Payment Order...' :
                                    generatePaymentOrderState.status === 'Failure' ? generatePaymentOrderState.error :
                                    paymentSuccessMsg}}
                                </div>
                                <div class="alert alert-danger" *ngIf="paymentErrorMsg">{{paymentErrorMsg}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Failure State -->
            <div *ngSwitchCase="'Failure'">
                <ng-container *ngTemplateOutlet="errorTemplate; context: {
                errorMessage: {
                    header: 'Order Not Found',
                    details: 'The order you\'re looking for doesn\'t exist. It might have been removed, renamed, or is temporarily unavailable.'
                },
                title: 'Error'
            }"></ng-container>
            </div>
        </div>
    </div>